

import { useParams } from 'react-router-dom'
import { useState, useEffect, useRef } from 'react'
import { apiFetch } from '@/lib/api'

import ChatBox from '@/components/ChatBox'
import { FiX, FiPlus, FiSend } from 'react-icons/fi'
import SegmentEditorModal from '@/components/modals/SegmentEditorModal'
import Segment from '@/components/Segment'
import { useModal } from '@/contexts/ModalContext'
import Button from '@/components/ui/Button'
import { UserRole } from '@/contexts/UserContext'
import { useShow } from '@/contexts/ShowContext'
import Scene from '@/components/Scene'

export default function RundownPage({ params }) {
    const { episodeId, segmentId } = useParams()
    const {show} = useShow()
    const [loading, setLoading] = useState(true)
    const [aiLoading, setAiLoading] = useState(false)
    const [error, setError] = useState(null)
    const [scenes, setScenes] = useState([])
    const [input, setInput] = useState('')
    const [insertIndex, setInsertIndex] = useState(-1)

    const { openModal } = useModal();
    const tableHeaderRef = useRef(null)

    const getData = async () => {
        setLoading(true)
        try{
            const response = await apiFetch(`/api/shows/${show._id}/episodes/${episodeId}/segments/${segmentId}/scenes`)
            if(!response.ok){
                throw new Error('Failed to fetch scenes')
            }
            const data = await response.json()
            setScenes(data)
        }
        catch(error){
            console.error('Error fetching scenes:', error)
            setError(error.message)
        }
        finally{
            setLoading(false)
        }
    }

    useEffect(() => {
        getData()
    }, [episodeId, segmentId])


    const handleScroll = (e) => {
        if (tableHeaderRef.current) {
            tableHeaderRef.current.scrollLeft = e.target.scrollLeft
        }
    }

    if (loading) {
        return (
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
            <img src={`${import.meta.env.BASE_URL}wsc-loader.gif`} alt="Loading" width={160} height={160} />
        </div>
        )
    }

    if (error) {
        return (
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
            <span className="text-red-400">Error: {error}</span>
        </div>
        )
    }

    return (
        <div className="flex flex-1 flex-col h-full">
            <div className='flex flex-1 flex-col overflow-hidden'>
                <div ref={tableHeaderRef} className='flex border-y bg-card h-12 items-stretch overflow-hidden' >
                    <div className='flex items-center justify-center px-4 border-r flex-none w-[400px]'>
                        <span className='text-secondary-foreground/80 text-sm capitalize'>Script</span>
                    </div>
                    {show.asset_categories.map((tag) => (
                        <div key={tag._id} className='flex items-center justify-center px-4 border-r flex-none w-60'>
                            <span className='text-secondary-foreground/80 text-sm capitalize'>{tag.name}</span>
                        </div>
                    ))}
                    <div className='flex items-center justify-center px-4 border-r flex-none w-60'>
                        <span className='text-secondary-foreground/80 text-sm capitalize italic'>Untagged</span>
                    </div>
                </div>
                <div onScroll={handleScroll} className='flex flex-col w-full overflow-auto flex-1 pb-6'>
                    {scenes.map((scene) => (
                        <Scene key={scene._id} data={scene} />
                    ))}                    
                </div>
            </div>                
            
            {aiLoading && <div className='absolute z-50 bottom-0 left-0 w-full h-full bg-black/90 flex items-center justify-center'>
                <img src={`${import.meta.env.BASE_URL}wsc-loader.gif`} alt="Loading" width={160} height={160} />
            </div>}
        </div>
    )
} 
